import React, { useContext, useEffect, useState } from "react";
import { Phase } from "../../types.ts";
import { OrderContext } from "../../OrderContext.tsx";
import { styled } from 'styled-components';
import { bp } from "../../../../../styles/breakPoints.tsx";
import logo from '../../../../../assets/images/lumme-logo.png';
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector.tsx";

interface PhasesProps {
  $phases: number;
}

const Phases = styled.div<PhasesProps>`

    width: 100%;
    overflow-x: hidden;
    white-space: nowrap;

  .phases {
    display: flex;
    justify-content: center;
    gap: 2px;
    padding: 20px 10px;
    margin: 0 auto;
    min-width: ${(props) => `${props.$phases * 80}px`};

    @media ${bp.sm} {
      padding: 20px 0;
    }

    &.b2b {
      min-width: ${(props) => `${props.$phases * 100}px`};
    }

    .phase {
      min-width: 80px;
      text-align: center;
      flex-shrink: 0;
      width: 24%;

      @media ${bp.sm} {
        width: 20%;
      }

      &.b2b {
        min-width: 100px;
        width: calc(${props => 100 / props.$phases - 3}% - 2px);
      }
    }
  }

  .label {
    color: #004107;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    white-space: nowrap;
  }

  .completed{
    .line {
      background-color: var(--Lime);
    }
  }

  .active {
    .line {
      background-color: var(--Laventeli);
    }
    .label {
      font-weight: 700;
    }
  }

  .line {
    display: block;
    height: 10px;
    width: 100%;
    background-color: #e4e4e4;
    border-radius: 50px;
    margin-bottom: 10px;
  }
`;

export const Header = styled.header`
    padding: 20px 0 0;
    background-color: var(--Valkoinen);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

  .logo {
    display: flex;
    justify-content: center;
  }

  .content {
    max-width: 1000px;
    width: 100%;

    button {
      position: absolute;
      margin-top: 0px;
      padding: 0px;
      margin-left: 10px;

      @media ${bp.md} {
        margin-top: 36px;
        margin-left: 20px;
      }

      svg {
        height: 25px;
        width: 25px;
      }
    }
  }

  img {
    height: 24px;
  }

`;

function PageHeader({ currentPhase, phases }: { currentPhase: Phase, phases: Phase[] }) {

  const [visiblePhases, setVisiblePhases] = useState(phases.filter(p => p.hideLabel != true));
  const { t } = useTranslation();

  const { toPhase } = useContext(OrderContext);

  const handlePhaseClick = (phase: number) => {
    if (currentPhase.key < phase) {
      return;
    }
    toPhase(phase, true)
  }

  const scrollPhases = (phase: number) => {
    let phaseId = `phase-${phase}`;
    const phaseElement = document.getElementById(phaseId) as HTMLElement;
    if (!phaseElement) {
      return;
    }
    phaseElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  useEffect(() => {
    scrollPhases(currentPhase.key);
  }, [currentPhase]);

  useEffect(() => {
    setVisiblePhases(phases.filter(p => p.hideLabel != true));
  }, [phases]);

  return (
    <Header>
      <div className="content">
        {currentPhase.key > 1 && currentPhase.key <= phases[phases.length - 2].key && <button
          type="button"
          onClick={() => toPhase(currentPhase.key - 1, true)}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M32 15H3.41l8.29-8.29-1.41-1.42-10 10a1 1 0 0 0 0 1.41l10 10 1.41-1.41L3.41 17H32z" data-name="4-Arrow Left" /></svg>
        </button>}
        <div className="logo">
          <img src={logo} alt="Lumme Energia logo" />
        </div>
        <Phases $phases={visiblePhases.length}>
          <div className={"phases" + (visiblePhases.length > 4 ? ' b2b' : '')}>
            {visiblePhases.map((phase) => (
              <div
                key={phase.value}
                id={`phase-${phase.key}`}
                className={`phase${visiblePhases.length > 4 ? ' b2b' : ''}` + (phase.value === currentPhase.value ? ' active' : (phase.key < currentPhase.key ? ' completed' : ''))}
                onClick={() => handlePhaseClick(phase.key)}>
                <span className="line"></span>
                <span className="label">{t(phase.label)}</span>
              </div>
            ))}
          </div>
        </Phases>
      </div>
      {/* <LanguageSelector /> */}
    </Header>
  );
}

export default PageHeader;
